// extracted by mini-css-extract-plugin
export default {"tipsMask":"index_tipsMask_PDsCP","textCenter":"index_textCenter_3WIsp","tipsText":"index_tipsText_8YcZG","openClient":"index_openClient_WyGOP"};